(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["livecool-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('livecool-card')) {
    customElements.define('livecool-card', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', event => {
          const swatch = event.target.closest('[data-swatch]');
          if (!swatch || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.querySelectorAll('[data-swatch]').forEach(item => item.removeAttribute('aria-current'));
          swatch.setAttribute('aria-current', 'true');
          this.querySelectorAll('[data-card-link]').forEach(link => link.href = swatch.href);
          this.querySelector('[data-card-price]').textContent = swatch.dataset.price;
          this.querySelector('[data-card-stock]').hidden = swatch.dataset.available === 'true';
          this.querySelector('[data-card-colour]').textContent = swatch.dataset.name;
          const image = this.querySelector('.lc-card__image');
          if (image && swatch.dataset.image) {
            image.removeAttribute('srcset');
            image.src = swatch.dataset.image;
            image.alt = `${this.querySelector('h3').textContent.trim()} — ${swatch.dataset.name}`;
          }
          this.dataset.colourSelected = 'true';
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
